import { ReflectUtils } from "@dooboostore/core";
const EventListenerMetadataKey = Symbol.for("simple-boot:event-listener-metadata");
const EventListener = (option) => {
  return ReflectUtils.metadata(EventListenerMetadataKey, option);
};
const getEventListener = (target, propertyKey) => {
  return ReflectUtils.getMetadata(EventListenerMetadataKey, target, propertyKey);
};
const eventListener = EventListener;
export {
  EventListener,
  eventListener,
  getEventListener
};
//# sourceMappingURL=EventListener.js.map
